import * as yup from 'yup';
import { FIELD_TYPE_VALIDATION, WHITESPACE_PATTERN } from 'Helpers/validations';
import { EditGroupValues } from './Group.types';
import {
	maxDigits,
	minDigits,
	nospace,
	tenantIdFieldValidationRules
} from 'Helpers/validations/validations.helpers';
import {
	HIERARCHY_LABEL_TENANT_VALUES,
	HIERARCHY_LABEL_GROUP_VALUES,
	HIERARCHY_LABEL_TENANT_FORBIDDEN,
	HierarchyLabelType
} from 'app-config';

const TENANT_ID_VALIDATION_RULES = FIELD_TYPE_VALIDATION.text
	.label('group.tenantID')
	.test(
		'is-no-space',
		nospace,
		(value = '') => !value.match(WHITESPACE_PATTERN)
	)
	.matches(/^[a-z\-_\d]+$/, tenantIdFieldValidationRules)
	.min(2)
	.max(50)
	.required();

const SYNC_CODE_VALIDATION = FIELD_TYPE_VALIDATION.text
	.label('group.syncCode')
	.nullable()
	.min(1, minDigits)
	.max(60, maxDigits);

export const tenantSchema = (maxGroupNameAmountCharacters: number) =>
	yup.object().shape<Partial<Record<keyof EditGroupValues, yup.AnySchema>>>({
		name: FIELD_TYPE_VALIDATION.text
			.min(2)
			.max(maxGroupNameAmountCharacters)
			.label('group.tenantName')
			.required(),
		active: yup.string().label('group.status').required(),
		syncCode: SYNC_CODE_VALIDATION,
		tenantId: TENANT_ID_VALIDATION_RULES,
		systemId: FIELD_TYPE_VALIDATION.text
			.label('group.systemName')
			.test(
				'is-no-space',
				nospace,
				(value = '') => !value.match(WHITESPACE_PATTERN)
			)
			.min(2)
			.max(50)
			.required(),
		hierarchyLabel: yup
			.string()
			.label('Hierarchy Label')
			.required('Hierarchy Label is required')
			.oneOf(
				HIERARCHY_LABEL_TENANT_VALUES as unknown as string[],
				'Tenants can only be assigned "Organization"'
			)
		.test(
			'tenant-forbidden-types',
			'Tenants cannot be assigned Group or Sub-Group',
			(value) =>
				!value ||
					!HIERARCHY_LABEL_TENANT_FORBIDDEN.includes(
						value as HierarchyLabelType
					)
			)
	});

export const editTenantSchema = (maxGroupNameAmountCharacters: number) =>
	yup.object().shape<Partial<Record<keyof EditGroupValues, yup.AnySchema>>>({
		name: FIELD_TYPE_VALIDATION.text
			.min(2)
			.max(maxGroupNameAmountCharacters)
			.label('group.tenantName')
			.required(),
		active: yup.string().label('group.status').required(),
		syncCode: SYNC_CODE_VALIDATION,
		tenantId: TENANT_ID_VALIDATION_RULES,
		hierarchyLabel: yup
			.string()
			.label('Hierarchy Label')
			.required('Hierarchy Label is required')
			.oneOf(
				HIERARCHY_LABEL_TENANT_VALUES as unknown as string[],
				'Tenants can only be assigned "Organization"'
			)
	});

export const groupSchema = (maxGroupNameAmountCharacters: number) =>
	yup.object().shape({
		name: FIELD_TYPE_VALIDATION.text
			.min(2)
			.max(maxGroupNameAmountCharacters)
			.label('group.groupName')
			.required(),
		active: yup.string().label('group.status').required(),
		syncCode: FIELD_TYPE_VALIDATION.text
			.label('group.syncCode')
			.nullable()
			.min(1, minDigits)
			.max(60, maxDigits),
		hierarchyLabel: yup
			.string()
			.label('Hierarchy Label')
			.required('Hierarchy Label is required')
			.oneOf(
				HIERARCHY_LABEL_GROUP_VALUES as unknown as string[],
				'Groups cannot be assigned "Organization"'
			)
	});
